export default "__VITE_ASSET__CjKSLO4l__"